module.exports = __webpack_public_path__ + "static/media/green-template-small.b2a34619.png";